import { UseDate } from './UseDate'
import { UseDateLimits } from './UseDateLimits'
import { UseSchedule } from './UseSchedule'

export const HOOKS_MENU = [
  'hooks',
  [
    ['useDate', UseDate], //
    ['useDateLimits', UseDateLimits],
    ['useSchedule', UseSchedule],
  ],
]
